import React from 'react';


class EventListener extends React.Component {

  componentDidMount() {
    const { type, handler } = this.props;
    document.addEventListener(type, handler);
  }

  componentWillUnmount() {
    const { type, handler } = this.props;
    document.removeEventListener(type, handler);
  }

  render() {
    return null;
  }
}


export {
  EventListener,
}



// WEBPACK FOOTER //
// ./src/components/misc/EventListener.js